import * as React from 'react';
import { Row, Col } from 'antd';

import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { ContextService } from 'src/core/services/context.service';
import { TourItineraryProductController } from 'src/app/products/tour-itineraries/form/parts/tour-itinerary-products.controller';

interface IGeneralViewProps extends ComponentViewProps<QuoteItineraryGroupSummary> {
	model: QuoteItineraryGroupSummary,
	mode: ControlMode;
	setBusy(isBusy: boolean);
	itinerary: TourItineraryItem;
	contextService: ContextService;
	defaultLanguage: string;
	service: ProductServiceTypeItem;
}

interface IGeneralViewState {

}

export default class GeneralView extends React.Component<IGeneralViewProps, IGeneralViewState> {
	public render(): React.ReactNode {
		return (
			<React.Fragment>
				<Row gutter={24}>
					<Col xs={12}>
						<Row gutter={24}>
							<Col xs={24}>
								<UserEditorController
									label='Managed by'
									readOnly
									mode={this.props.mode}
									value={this.props.model.managedById}
									setBusy={this.props.setBusy}
								/>
							</Col>
						</Row>
					</Col>
					<Col xs={12}>
						<Row gutter={24}>
							<Col xs={12}>
								<DateView
									readOnly
									mode={this.props.mode}
									format='small-date-time'
									value={this.props.model.dateFrom}
									label='Date from'
								/>
							</Col>
							<Col xs={12}>
								<DateView
									readOnly
									mode={this.props.mode}
									format='small-date-time'
									value={this.props.model.dateTo}
									label='Date to'
								/>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col xs={12}>
						<h3>{this.props.itinerary.dynamicProperties["displayName"][this.props.defaultLanguage]}</h3>
					</Col>
					<Col xs={12}>
						<h3><strong>Service: </strong> {this.props.service.dynamicProperties['displayName'][this.props.defaultLanguage]}</h3>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col xs={24}>
						{!!this.props.itinerary && <TourItineraryProductController
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
							model={this.props.itinerary}
							readOnly
							fromDate={this.props.model.dateFrom}
						/>}
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/general.view.tsx